import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { Section, Panel } from './shared';

const useStyles = makeStyles(theme => ({
  panel: {
    padding: theme.spacing(0.75, 2),
    [theme.breakpoints.down('xs')]: { padding: theme.spacing(0.5, 1.5) },
  },
  list: {
    margin: 0,
    padding: 0,
    listStyle: 'none',
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr)',
    columnGap: theme.spacing(4),
    [theme.breakpoints.up('sm')]: {
      gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
      '& > li:last-child:nth-child(odd)': { gridColumn: '1 / -1' },
    },
  },
  item: {
    minWidth: 0,
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
    padding: theme.spacing(1.5, 0),
    borderBottom: '1px solid var(--dm-border, #e7ebf0)',
    [theme.breakpoints.down('xs')]: { gap: theme.spacing(1), padding: theme.spacing(1.25, 0) },
  },
  marker: {
    flex: '0 0 auto',
    width: 8,
    height: 8,
    marginTop: 7,
    borderRadius: '50%',
    background: '#3D7DDD',
    boxShadow: '0 0 0 4px rgba(61, 125, 221, .11)',
  },
  line: {
    color: 'var(--dm-text-strong, #263548)',
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: 1.55,
  },
}));

/** `summary[]` rendered exactly as the API wrote it. */
const AiSummary = ({ items = [] }) => {
  const classes = useStyles();
  if (!items.length) return null;
  return (
    <Section id="highlights" title="Highlights" exportKey="highlights">
      <Panel className={classes.panel}>
        <ul className={classes.list}>
          {items.map((item, index) => (
            <li key={index} className={classes.item}>
              <span className={classes.marker} aria-hidden="true" />
              <Typography component="span" className={classes.line}>{item}</Typography>
            </li>
          ))}
        </ul>
      </Panel>
    </Section>
  );
};

export default AiSummary;
